module.exports = __webpack_public_path__ + "img/search-by-keyword-country.e1f108b2.png";